<template>
<div class="size margin">

  <div class="example">

    <titleComponent value="Logos" mark="01" color="background-red" button="Ver mais" />

    <div class="container wrap">

      <div class="flex-grow-1 container wrap ">
        <div class="logo">
          <img src="@/assets/img/logos/logo-black.svg" width="150" alt="Minds">
        </div>
        <div class="logo">
          <img src="@/assets/img/logos/logo-black-red.svg" width="150" alt="Minds">
        </div>
        <div class="logo">
          <img src="@/assets/img/logos/logo-black-green.svg" width="150" alt="Minds">
        </div>
        <div class="logo">
          <img src="@/assets/img/logos/logo-black-blue.svg" width="150" alt="Minds">
        </div>
        <div class="logo">
          <img src="@/assets/img/logos/logo-all-black.svg" width="150" alt="Minds">
        </div>
      </div>

      <div class="flex-grow-1 container wrap ">
        <div class="logo black">
          <img src="@/assets/img/logos/logo.svg" width="150" alt="Minds">
        </div>
        <div class="logo black">
          <img src="@/assets/img/logos/logo-red.svg" width="150" alt="Minds">
        </div>
        <div class="logo black">
          <img src="@/assets/img/logos/logo-green.svg" width="150" alt="Minds">
        </div>
        <div class="logo black">
          <img src="@/assets/img/logos/logo-blue.svg" width="150" alt="Minds">
        </div>
        <div class="logo black">
          <img src="@/assets/img/logos/logo-white.svg" width="150" alt="Minds">
        </div>
      </div>

    </div>
  </div>


</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'

export default {
  name: 'logos',
  components: {
    titleComponent
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.logo {
    margin: 20px;
    padding: 20px;
    box-sizing: border-box;
}
.logo.black {
    background: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/styleguide/logos.vue